<div *ngIf="offer" class="card-height">
  <div class="fruit-card" (click)="navigateToDetail()" onKeyPress="">
    <div class="fruit-img-container">
      <figure class="fruit-figure">
        <img
          loading="lazy"
          class="fruit-img"
          [src]="getExportOfferImageUrl(offer, 0)"
          [alt]="offer.variety.species.name"/>
      </figure>
    </div>
    <div class="flex flex-column fruit-data-container">
      <div class="flex flex-row justify-content-between gap-1">
        <span *ngIf="offer.harvestDate">
          {{'ProductsCardInfo.harvest' | translate}}:
          {{offer.harvestDate | date: 'dd/MM/yy'}}
        </span>

        <span *ngIf="offer.netKilos" class="text-center">
          {{offer.netKilos}}
          {{'ProductsCardInfo.netKilos' | translate}}
        </span>

        <span *ngIf="offer.caseQuantityPerPallet" class="text-right">
          {{offer.caseQuantityPerPallet}}
          {{'ProductsCardInfo.casesPerPallet' | translate}}
        </span>
      </div>

      <div class="flex flex-row justify-content-between pt-3 h-full">
        <div class="flex flex-column">
          <span class="text-lg font-bold text-gray-900">
            {{offer.variety.species | speciesName}}
          </span>

          <div>
            <span>{{'ProductsCardInfo.variety' | translate}}: </span>
            <span class="text-gray-900 font-bold">{{offer.variety.name}}</span>
          </div>

          <div>
            <span>{{'ProductsCardInfo.speciesSize' | translate}}: </span>
            <span class="text-gray-900 font-bold">{{offer.speciesSize}}</span>
          </div>

          <div>
            <span>{{'ProductsCardInfo.category' | translate}}: </span>
            <span class="text-gray-900 font-bold">{{offer.category}}</span>
          </div>
        </div>

        <div class="flex flex-column text-right justify-content-end">
          <div *ngIf="offer.fridgeStorage?.contactCountry">
            <img
              class="country-img"
              [flag]="offer.fridgeStorage?.contactCountry?.code"
              alt=""/>
          </div>

          <div>
            <span class="text-lg font-bold price-color">
              {{(pricePerCase ?? offer.listPrice) | currency: 'USD' : '$'}}
            </span>
            <span class="text-xs price-color">
              /{{offer.typeSale}} USD
            </span>
          </div>

          <span>
            {{'ProductsCardInfo.available' | translate}}:
            {{offer.availablePallets ?? offer.palletQuantity}}
            {{'ProductsCardInfo.pallets' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
